import {TYPE_CLEAR_LOCATION_TO_CHANGE_TO} from "./types";

export function clearLocationToChangeToAction() {
	return {
		type: TYPE_CLEAR_LOCATION_TO_CHANGE_TO,
	};
}
